import React, { useState } from 'react';

import { Toolbar, ToolbarItem, Button, ButtonGroup } from "@progress/kendo-react-buttons";

import QueryViewIndividualFieldView from 'views/admin/queries/QueryViewIndividualFieldView.jsx';
import AttributeSelectionDialog from 'views/widgets/AttributeSelectionDialog.jsx';

export default function AttributeTagSearchViewer(props) {
	
	const { attributes, attributesChanged } = props;
	const [ selectionDialogVisible, setSelectionDialogVisible ] = useState(false);
	
	const enumMapping = {
		'STRING': 'String',
		'NUMBER': 'Number',
		'DATE': 'Date',
		'TIMESTAMP': 'Timestamp',
		'BOOLEAN': 'Boolean',
		'PICKLIST': 'Pick List',
		'MULTIVALUE': 'Multi Value' 
	};
	const enumLookup = (type) => {
		for(let key in enumMapping) {
			if (enumMapping[key] === type)
				return key;
		}
		return null;
	};
	
	
	/* Event Handling */
	
	const addAttributes = (newAttrs) => {
		let newAttributes = attributes;
		for (let i = 0; i < newAttrs.length; i++) {
			if (attributes.filter(attr => attr.id == newAttrs[i].id).length == 0)
				newAttributes.push({...newAttrs[i], type: enumLookup(newAttrs[i].type)});
		}
		newAttributes = newAttributes.map((attribute) => {
			if (attribute.type === 'BOOLEAN' && attribute.value === null)
				return {...attribute, value: false};
			else if (attribute.type === 'NUMBER' || attribute.type === 'DATE' || attribute.type === 'TIMESTAMP' && attribute.value === null)
				return {...attribute, value: JSON.stringify({ from: null, to: null })};
			else if (attribute.value === null)
				return {...attribute, value: ""};
			else
				return attribute;
		});
		newAttributes.sort((a, b) => {
			let fa = a.name.toLowerCase(), fb = b.name.toLowerCase();
			if (fa < fb) return -1;
			else return 1;
		});
		attributesChanged(newAttributes);
		setSelectionDialogVisible(false);
	};
	
	const attributeRemoved = (field) => {
		attributesChanged(attributes.filter((attribute) => attribute.id !== field.id));
	};
	
	const attributeValueChanged = (attribute, newValue) => {
		attributesChanged(attributes.map((attr) => {
			if (attr.id === attribute.id) {
				let newValueTransformed = newValue;
				if (attribute.type === 'DATERANGE' || attribute.type === 'TIMESTAMPRANGE' || attribute.type === 'NUMERICRANGE')
					newValueTransformed = JSON.stringify(newValue);
				return {...attr, value: newValue == null ? "" : newValueTransformed};
			} else
				return attr;
		}));
	}
	
	
	/* Helper Functions */
	
	const getFields = () => {
		let orderIdx = 0;
		return attributes.map((attribute) => {
			if (attribute.type === 'BOOLEAN') 
				return { id: attribute.id, name: attribute.name, type: 'BOOLEAN', searchable: true, config: false, order: orderIdx++, value: attribute.value ? true : false };
			else if (attribute.type === 'DATE')
				return { id: attribute.id, name: attribute.name, type: 'DATERANGE', format: attribute.format, searchable: true, config: false, order: orderIdx++, value: JSON.parse(attribute.value) };
			else if (attribute.type === 'TIMESTAMP')
				return { id: attribute.id, name: attribute.name, type: 'TIMESTAMPRANGE', format: attribute.format, searchable: true, config: false, order: orderIdx++, value: JSON.parse(attribute.value) };
			else if (attribute.type === 'NUMBER')
				return { id: attribute.id, name: attribute.name, type: 'NUMERICRANGE', searchable: true, config: false, order: orderIdx++, value: JSON.parse(attribute.value) };
			else if (attribute.type === 'PICKLIST') {
				let choices = JSON.parse(attribute.choices);
				let choiceStr = choices.map(choice => choice.name).join("\n");
				return { id: attribute.id, name: attribute.name, type: 'COMBOBOX', searchable: true, 
					config: JSON.stringify({ choices: choiceStr }),
					order: orderIdx, value: attribute.value };
			} else 
				return { id: attribute.id, name: attribute.name, type: 'STRING', searchable: true, config: false, order: orderIdx++, value: attribute.value };
		});
	};
	
	
	/* Render Functions */

	const getAttributeViews = () => { 
		let fields = getFields();
		return fields.map((field) => {
			return (
				<div key={field.id} style={{ width: "100%" }}>
					<QueryViewIndividualFieldView
						key={field.id}
						field={field}
						fieldValue={field.value}
						fieldStyle={{
							color: "black",
							backgroundColor: "white",
							fontSize: "10pt",
							padding: "10px"
						}}
						viewStyle={{}}
						fieldUpdated={()=>{}}
						fieldRemoved={()=>{}}
						fieldValueChanged={attributeValueChanged}
						wrapped={false}
						isEditable={false}
						contextMenuVisible={false}
						contextMenuOffset={{}}
						displayContextMenu={()=>{}}
						onDragStart={()=>{}}
						onDragOver={()=>{}}
						onDrop={()=>{}}
						runSearch={()=>{}}
					/>
	 				<div style={{ width: "50px", display: "inline-block" }}>
 						<Button key="remove-attribute-button" iconClass="fa fa-fw fa-trash" title="Remove Attribute"
 							onClick={() => { attributeRemoved(field); }}/>
					</div>
				</div>
			);
		});
	};
	
	return (
		<div
			tabIndex="0"
			role="region"
			aria-label="Attributes Tag Search"
			className="constituo-tab-container">
			<Toolbar className="constituo-small-toolbar">
				<ToolbarItem>
					<ButtonGroup>
						<Button 
							key="add-attribute-button"
							iconClass="fa fa-fw fa-plus"
							title="Add Attribute"
							onClick={() => { setSelectionDialogVisible(true); }}
						/>
					</ButtonGroup>
				</ToolbarItem>
			</Toolbar>
			<div 
				className="constituo-attributes-tag-container"
				style={{
					height: "calc(100% - 60px)",
					width: "100%",
					overflow: "auto"
				}}
			>
				<div style={{ width: "100%", height: "100%" }} >
					{getAttributeViews()}
				</div>
			</div>
			{selectionDialogVisible &&
				<AttributeSelectionDialog
					additionalUrlParams="&includeDeleted=false&tagOnly=true&listOnly=true"
					closeCallback={() => { setSelectionDialogVisible(false); }}
					initialHeight={600}
					initialWidth={700}
					okCallback={addAttributes}
				/>	
			}
		</div>
	);
}